module.exports = __webpack_public_path__ + "img/Frame_42.1ca741ae.png";